import { createContext, useEffect, useState } from "react";



export const NewsContext = createContext({
NewsMap : []
})

export const NewsProvider = ({children}) => {
    const [NewsMap , setNewsMap] = useState([])
    useEffect(() => {
        // API endpoint disabled - using empty array
        // fetch("https://api.reverhotel.uz/news")
        // .then(res => res.json())
        // .then(respons => setNewsMap(respons))
    } , []) // Fixed: removed NewsMap from dependency to prevent infinite loop
    const value = {NewsMap}

    return(
        <NewsContext.Provider value={value}>{children}</NewsContext.Provider>
        )
}